'use strict'

export default class AddModelController {

  /*@ngInject*/
  constructor ($http, $state) {
    this.$http = $http
    this.$state = $state
    this.newModel = {}
  }

  save () {
    this.$http.post(`/api/myScriptModels`, this.newModel).then(res => {
      this.$state.go('myscripts.model')
    })
  }
}



// WEBPACK FOOTER //
// ./client/app/myscripts/addModel/addModel.controller.js